import { Component, Input, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Offer } from 'app/services/offers/offer.model';
import { SaveDealStatus } from 'app/store/deal/deal/deal.actions';
import { ClearOfferError, CreateOffer, PublishOffer, ToggleOffer, UpdateOffer } from 'app/store/offers/offer.actions';
import { OfferState } from 'app/store/offers/offer.state';
import { OfferOption } from 'ng2-app/models/dto/offer-option/offer-option.model';
import { GetOfferOptions } from 'app/store/offers/offer-options.actions';
import { OfferOptionsState } from 'app/store/offers/offer-options.state';
import { Observable} from 'rxjs';
import { map, take } from 'rxjs/operators';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';
import { LenderUser } from 'app/models/dto/lender-user.model';

@Component({
  selector: 'app-offer-smart',
  templateUrl: './offer-smart.component.html',
  styleUrls: ['./offer-smart.component.scss']
})
export class OfferSmartComponent implements OnInit {

  @Select(OfferState.loading) loadingOffers$: Observable<boolean>;
  @Select(OfferState.error) updateOfferError$: Observable<string>;
  @Select(LenderUserState.lenderUser) lenderUser$: Observable<LenderUser>;
  @Select(OfferOptionsState.offerOptions) offerOptions$: Observable<OfferOption[] | null>; 

  @Input() dealId: number;
  @Input() dealStage: string;
  @Input() loanProductType: string;
  @Input() readOnly: boolean = false;

  user: LenderUser;
  dealOffers$: Observable<Offer[]>;
  fundedOffer$: Observable<Offer[]>;
  acceptedOfferId$: Observable<number | null>;

  constructor(private store: Store) { }


  async ngOnInit() {
    this.lenderUser$.pipe(take(1)).subscribe(user =>{
      this.user = user;
    });
    this.dealOffers$ = this.store.select(OfferState.dealOffers).pipe(map(filterFn => filterFn(this.dealId, this.dealStage)));
    this.fundedOffer$ = this.store.select(OfferState.fundedOffer).pipe(map(filterFn => filterFn(this.dealId)));
    this.acceptedOfferId$ = this.store.select(OfferState.acceptedOfferId).pipe(map(filterFn => filterFn(this.dealId)));
  }


  publishOffer(offerId: number) {
    this.store.dispatch(new PublishOffer(offerId, this.user.id, new Date().getTime())).pipe(
      take(1)
    ).subscribe(() => {
      this.store.dispatch(new SaveDealStatus(this.dealId, 'underwriting', 'offerToBorrower', '', [], []));
    });
  }

  canEdit() {
    return (
      !this.readOnly
      && this.user
      && this.user.permissions.includes('manageDeals')
      && this.user.permissions.includes('editOffers')
    );
  }

  canEditInactiveOffers() {
    return (this.user && this.user.permissions.includes('editInactiveOffers'));
  }

  canDelete() {
    return this.user && this.user.permissions.includes('manageDeals');
  }

  acceptedToggle(offer: { id: number, checked: boolean }) {
    this.store.dispatch(new UpdateOffer(offer.id, { accepted: offer.checked ? new Date().getTime() : null }));
  }

  expandToggle(offerId: number) {
    this.store.dispatch(new ToggleOffer(offerId));
  }

  createOffer(offer: Offer) {
    offer.dealId = this.dealId;
    this.store.dispatch(new CreateOffer(offer));
  }

  editOffer({ offer }) {
    this.store.dispatch(new UpdateOffer(offer.id, offer));
  }

  dismissAlert() {
    this.store.dispatch(new ClearOfferError());
  }

}
